import React, { useState, useEffect } from 'react'
import { Alert, Button, Card, Col, Container, Form, InputGroup, Row, Spinner } from 'react-bootstrap'
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import { Link, useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import ConfigLayout from '../../Layouts/ConfigLayout'
import { LoginSchema } from '../../../utils/validation'
import { loginUser } from '../../../redux/actions/user'
import { useDispatch, useSelector } from 'react-redux'

const Login = () => {
  const [show, setShow] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const dispatch = useDispatch()
  

  const { user, loginState, logoutState } = useSelector((state) => ({
    loginState: state.user.login,
    logoutState: state.user.logout,
    user: state.user.user
  }))

  useEffect(() => {
    if (loginState.error !== false) {
      setShow(true)
    }
  }, [loginState.error])

  useEffect(() => {
    if (logoutState.success) {
      window.location.reload(false)
    }
  }, [logoutState.success])

  const history = useHistory()

  useEffect(() => {
    if (loginState.success) {
      if (user.userId === 1) {
        history.push('/configurator')
      } else {
        history.push('/validate')
      }
    }
  }, [loginState.success])

  const login = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    enableReinitialize: true,
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      dispatch(loginUser(values))
    }
  })

  return (
    <ConfigLayout showUser={false}>
      <Container fluid id='login'>
        <Row>
          <Col xs={12} className='mb-3'>
            <Card className='auth-container mx-auto'>
              <Card.Body>
                <Form onSubmit={login.handleSubmit} noValidate>
                  <Row>
                    <Col xs={12}>
                      <h3>Log In</h3>
                      <Alert 
                        show={show} 
                        dismissible
                        variant='danger'
                        onClose={() => setShow(false)}
                      >
                        {loginState.error.message}
                      </Alert>
                    </Col>
                    <Form.Group as={Col} xs={12} className='mb-3'>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        id='email'
                        name='email'
                        type='email'
                        onChange={login.handleChange}
                        onBlur={login.handleBlur}
                        isInvalid={!!login.errors.email && login.touched.email}
                        value={login.values.email}
                        autoComplete='email'
                      />
                      <Form.Control.Feedback type='invalid'>
                        {login.errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} xs={12} className='mb-3'>
                      <Form.Label>Password</Form.Label>
                      <InputGroup>
                        <Form.Control
                          id='password'
                          name='password'
                          type={showPassword ? 'text' : 'password'}
                          onChange={login.handleChange}
                          onBlur={login.handleBlur}
                          isInvalid={!!login.errors.password && login.touched.password}
                          value={login.values.password}
                          autoComplete='current-password'
                        />
                        <InputGroup.Append>
                          <Button className='font-85' variant='secondary' onClick={() => setShowPassword((ps) => !ps)}>
                            {showPassword ? <Eye size={14} /> : <EyeSlash size={14} />}
                          </Button>
                        </InputGroup.Append>
                        <Form.Control.Feedback type='invalid'>
                          {login.errors.password}
                        </Form.Control.Feedback>
                      </InputGroup>
                      <Form.Text>
                        <Link to='/forgot-password'>Forgot Password?</Link>
                      </Form.Text>
                    </Form.Group>
                    <Col xs={12} className='mb-3'>
                      <Button
                        type='submit'
                        className='w-100'
                        disabled={loginState.loading}
                      >
                        {
                          loginState.loading
                            ? (
                              <Spinner animation='border' role='status' />
                            )
                            : 'Log In'
                        }
                      </Button>
                    </Col>
                    <Col xs={12}>
                      <div>
                        Need Help? Send email to: <u><a href='mailto:lupusadvisor@pocp.com' className='text-muted'>lupusadvisor@pocp.com</a></u>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} className='text-center mb-3'>
            <h4>
              <u><a className='text-muted' href='https://info.pocp.com/lupus_advisor' target='_blank' rel='noreferrer'>About Lupus Advisor</a></u>
            </h4>
          </Col>
          <Col xs={12} className='text-center'>
            <div className='text-muted'>
              Lupus Advisor Configurator is available to current customers of Lupus Advisor.
            </div>
          </Col>
        </Row>
      </Container>
    </ConfigLayout>
  )
}

export default Login
